<div style="text-align:center">
   <!-- <img [src]="'assets/images/logo/logo_blue.svg'" alt="" width="100px" heigth="100px">-->
        <h2><u>Ajouter ou modifier les photos du véhicule</u></h2> 
</div>
<div fxLayout="row" fxLayoutAlign="start end end" style="margin-right:20px;  margin-top:50px">
    <div fxFlex="50">
        <button mat-flat-button (click)="drop.showFileSelector()" color="primary"
           >Ajouter</button>
        <button mat-flat-button (click)="onRemoveAll()"
            style="margin-left:15px;background-color: grey !important;color:white !important">Effacer</button>
    </div>
</div>
<div fxLayout="row" style="margin-top:25px">
   
    <div fxFlex="100">
        <ngx-dropzone #drop (change)="onSelect($event)" [maxFileSize]="3072000" [disableClick]="true">
            <ngx-dropzone-label>
                <button mat-icon-button color="primary" (click)="drop.showFileSelector()">
                    <mat-icon>file_upload</mat-icon>
                </button>
                <h5 style="color:red">Inserez au moins une Image *</h5>
                <h6>Taille Maximal du fichier: 2Mo</h6>
                <h6>Maximun: 8 images</h6>
            </ngx-dropzone-label>
            <div *ngFor="let f of saveFile; let z=index;let zlast = last"
                style="width:200px;text-align:center;font-size:15px;">
                <ngx-dropzone-image-preview class="image-drop" ngProjectAs="ngx-dropzone-preview" [file]="f"
                    [removable]="true" (removed)="onRemove(f)" (click)="seeFile(f)" >
                </ngx-dropzone-image-preview>
                <span class="dzlabel">Image {{z+1}}</span>
            </div>
        </ngx-dropzone>
    </div>
</div>
<div fxLayout="row" fxLayoutAlign="center center" style="margin-right:20px;  margin-top:50px">
        <button mat-flat-button color="warn" style="margin:15px" (click)="onNoClick()">Annuler</button>
        <button mat-flat-button color="primary" style="margin:15px" [disabled]="saveFile.length ==0 " (click)="saveAllFile()">Enregister</button>
</div>